(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('mdb-header-nav')) {
    customElements.define(
      'mdb-header-nav',
      class extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('details.mdb-header__dd'));
          if (!this.items.length) return;
          this.hover = window.matchMedia('(hover: hover) and (pointer: fine)');

          this.items.forEach((details) => {
            const summary = details.querySelector('summary');
            summary.setAttribute('aria-expanded', 'false');

            details.addEventListener('toggle', () => {
              summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
              if (details.open) this.items.forEach((other) => other !== details && (other.open = false));
            });

            // mouse: open on hover, keep open on click (keyboard Enter still toggles)
            details.addEventListener('mouseenter', () => {
              if (!this.hover.matches) return;
              clearTimeout(details.mdbTimer);
              details.open = true;
            });
            details.addEventListener('mouseleave', () => {
              if (!this.hover.matches) return;
              details.mdbTimer = setTimeout(() => (details.open = false), 160);
            });
            summary.addEventListener('click', (event) => {
              if (this.hover.matches && event.detail > 0) {
                event.preventDefault();
                details.open = true;
              }
            });

            details.addEventListener('focusout', (event) => {
              if (!details.contains(event.relatedTarget)) details.open = false;
            });
            details.addEventListener('keyup', (event) => {
              if (event.key === 'Escape' && details.open) {
                details.open = false;
                summary.focus();
              }
            });
          });

          this.onDocumentClick = (event) => {
            if (!this.contains(event.target)) this.close();
          };
          document.addEventListener('click', this.onDocumentClick);
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
        }

        close() {
          (this.items || []).forEach((details) => (details.open = false));
        }
      }
    );
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu, mdb-header-nav');
      this.disclosures.forEach((disclosure) => disclosure.close && disclosure.close());
      this.header.querySelectorAll('details.mdb-lang[open]').forEach((details) => (details.open = false));
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // Language selector: close on a click outside, Escape or when focus leaves it;
  // only one dropdown (menu or language) is open at a time.
  if (!window.mdbHeaderLang) {
    window.mdbHeaderLang = true;
    const closeLang = (except) =>
      document.querySelectorAll('details.mdb-lang[open]').forEach((details) => {
        if (details !== except) details.open = false;
      });

    document.addEventListener('click', (event) => {
      document.querySelectorAll('details.mdb-lang[open]').forEach((details) => {
        if (!details.contains(event.target)) details.open = false;
      });
    });

    document.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('details.mdb-lang[open]').forEach((details) => {
        details.open = false;
        details.querySelector('summary').focus();
      });
    });

    document.addEventListener('focusout', (event) => {
      const details = event.target.closest && event.target.closest('details.mdb-lang');
      if (details && details.open && event.relatedTarget && !details.contains(event.relatedTarget)) details.open = false;
    });

    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.open) {
          if (details instanceof HTMLDetailsElement && details.matches('.mdb-lang')) {
            details.querySelector('summary').setAttribute('aria-expanded', 'false');
          }
          return;
        }
        if (details.matches('.mdb-lang')) {
          details.querySelector('summary').setAttribute('aria-expanded', 'true');
          closeLang(details);
          document.querySelectorAll('mdb-header-nav').forEach((nav) => nav.close && nav.close());
        } else if (details.matches('.mdb-header__dd')) {
          closeLang(null);
        }
      },
      true
    );
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
